/*
 * @Description: 运单数据模块企业白名单配置
 * @Author: yuanmc
 * @Date: 2025-11-04
 * @LastEditTime: 2025-11-04
 * @LastEditors: yuanmc
 */

/**
 * 企业ID到租户Code的映射关系
 * 当企业ID在白名单中时，使用映射后的租户Code进行API调用
 */
const BUSINESS_ID_TO_TENANT_CODE_MAP = {
  saas_5shyyn0x7gg: '8ecc6332e2dc4070b6b4987df55ad291',
  saas_9khgv5dugio: 'YAHUA0001',
};

/**
 * 运单数据模块可访问的企业ID白名单（生产环境）
 * 只有在此列表中的企业ID才能看到"运单数据"菜单和访问相关页面
 */
const PRODUCTION_WHITELIST = [
  'saas_5shyyn0x7gg', // 默认企业（会映射到租户Code：8ecc6332e2dc4070b6b4987df55ad291）
  'saas_9khgv5dugio',
  // 可以在此添加更多企业ID
];

/**
 * 运单数据模块可访问的企业ID白名单（开发/测试环境）
 * 开发环境可以使用更宽松的白名单或空数组（表示所有企业都可以访问）
 */
const DEVELOPMENT_WHITELIST = [
  'saas_5shyyn0x7gg', // 默认企业
  'saas_9khgv5dugio',
  // 开发环境可以添加更多测试企业ID
];

/**
 * 根据环境获取对应的白名单
 * @returns {string[]} - 当前环境的白名单数组
 */
function getWhitelistByEnv() {
  console.log('process.env.NODE_ENV', process.env.NODE_ENV);
  const isDevelopment = process.env.NODE_ENV === 'development';
  return isDevelopment ? DEVELOPMENT_WHITELIST : PRODUCTION_WHITELIST;
}

/**
 * 运单数据模块可访问的企业ID白名单
 * 根据环境自动选择对应的白名单配置
 */
export const WAYBILL_DATA_WHITELIST = getWhitelistByEnv();

/**
 * 检查当前企业是否有运单数据访问权限
 * @param {string} businessId - 企业ID
 * @returns {boolean} - 是否有权限
 */
export function hasWaybillDataPermission(businessId) {
  return WAYBILL_DATA_WHITELIST.includes(businessId);
}

/**
 * 获取当前企业ID
 * @returns {string} - 当前企业ID
 */
export function getCurrentBusinessId() {
  return localStorage.getItem('aicurrentData') || localStorage.getItem('aiBid');
}

/**
 * 检查当前企业是否有运单数据访问权限
 * @returns {boolean} - 是否有权限
 */
export function checkCurrentBusinessPermission() {
  const currentBusinessId = getCurrentBusinessId();
  return hasWaybillDataPermission(currentBusinessId);
}

/**
 * 根据企业ID获取对应的租户Code
 * 如果企业ID在映射表中，返回映射后的租户Code；否则返回原企业ID
 * @param {string} businessId - 企业ID
 * @returns {string} - 租户Code
 */
export function getTenantCodeByBusinessId(businessId) {
  return BUSINESS_ID_TO_TENANT_CODE_MAP[businessId] || businessId;
}
